var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useState, useEffect } from 'react';
import { Input } from 'reactstrap';
import { mapToCssModules } from '../../utils/className';
export const SmlsInputToken = (_a) => {
    var { idInput = '', idLoading = '', idValid = '', idErrorMsg = '', textLabel, labelId = '', className = '', disabled = false, maxLength, flipFlopClear, errorMessage = '', ref, onChange = () => undefined, onKeyPress = () => undefined, onFocus = () => undefined, onBlur = () => undefined, onPaste = () => undefined } = _a, params = __rest(_a, ["idInput", "idLoading", "idValid", "idErrorMsg", "textLabel", "labelId", "className", "disabled", "maxLength", "flipFlopClear", "errorMessage", "ref", "onChange", "onKeyPress", "onFocus", "onBlur", "onPaste"]);
    const [isFocused, setIsFocused] = useState(false);
    const [isFilled, setIsFilled] = useState(false);
    const [isTyping, setIsTyping] = useState(false);
    const [value, setValue] = useState('');
    const enableOutline = useCallback((e) => {
        setIsFocused(true);
        onFocus(e);
    }, []);
    const disableOutline = useCallback((e) => {
        setIsFocused(false);
        onBlur(e);
    }, []);
    const handleOnChange = useCallback((event) => {
        const text = event.target.value;
        setValue(text.slice(0, maxLength).replace(/[^0-9]/g, ''));
        onChange(Object.assign(Object.assign({}, event), { target: {
                value: text,
            } }));
    }, [value]);
    useEffect(() => {
        setIsFilled(value.length === maxLength);
        setIsTyping(value.length > 0 && value.length < maxLength);
    }, [value]);
    useEffect(() => {
        setValue('');
    }, [flipFlopClear]);
    return (React.createElement("div", { className: mapToCssModules([
            'input-group',
            'token',
            isTyping ? 'typing' : '',
            errorMessage ? 'error' : '',
            isFilled && !errorMessage ? 'filled' : '',
            disabled ? 'disabled' : '',
            isFocused && !isFilled ? 'input-outline' : '',
        ]) },
        textLabel && (React.createElement("label", { id: labelId, htmlFor: textLabel }, textLabel)),
        React.createElement("div", null,
            React.createElement(Input, Object.assign({ id: idInput, type: "number", inputMode: "numeric", className: className, disabled: disabled, value: value, ref: ref, onChange: handleOnChange, onFocus: enableOutline, onBlur: disableOutline, placeholder: new Array(maxLength).fill(0).join(''), maxLength: maxLength, onKeyPress: onKeyPress, onPaste: onPaste }, params)),
            React.createElement("i", { id: idValid, className: "material-icons filled notranslate" }, "\uE876"),
            React.createElement("div", { id: idLoading, className: "typing" },
                React.createElement("span", { className: "dot" }),
                React.createElement("span", { className: "dot" }),
                React.createElement("span", { className: "dot" }))),
        React.createElement("div", { id: idErrorMsg, className: "input-error" }, errorMessage && (React.createElement(React.Fragment, null,
            React.createElement("i", { className: "material-icons error notranslate" }, "\uE001"),
            React.createElement("label", { htmlFor: "input-text" }, errorMessage))))));
};
//# sourceMappingURL=index.js.map